export const PHONE_W = 280;
export const PHONE_H = 560;
const PhoneFrame = ({ children }) => {
  return (
    <div
      className="relative shrink-0"
      style={{ width: PHONE_W, height: PHONE_H }}
    >
      {/* Left buttons — action button + 2 volume buttons */}
      <div className="absolute -left-[3px] top-[100px] w-[3px] h-[28px] bg-zinc-500 rounded-l-sm" />
      <div className="absolute -left-[3px] top-[148px] w-[3px] h-[44px] bg-zinc-500 rounded-l-sm" />
      <div className="absolute -left-[3px] top-[200px] w-[3px] h-[44px] bg-zinc-500 rounded-l-sm" />

      {/* Right button — power */}
      <div className="absolute -right-[3px] top-[168px] w-[3px] h-[64px] bg-zinc-500 rounded-r-sm" />

      <div className="relative w-full h-full rounded-[2.5rem] shadow-xl border-[5px] border-black outline outline-2 outline-zinc-400 overflow-clip flex flex-col">
        {/* Status bar */}
        <div className="relative z-10 shrink-0 flex items-center justify-between px-6 pt-3 pb-2 bg-white">
          {/* Time */}
          <span className="text-xs font-semibold text-zinc-900">10:40</span>

          {/* Dynamic Island pill + camera — absolutely centered */}
          <div className="absolute left-1/2 -translate-x-1/2 w-[84px] h-[24px] bg-black rounded-full flex items-center justify-end pr-1.5">
            <div className="w-2.5 h-2.5 rounded-full bg-zinc-900 flex items-center justify-center">
              <div
                className="w-1.5 h-1.5 rounded-full"
                style={{
                  background:
                    "conic-gradient(from 180deg, #3f3f46, #18181b, #18181b, #18181b, #3f3f46, #18181b, #18181b, #18181b, #3f3f46)",
                }}
              />
            </div>
          </div>

          {/* Signal + WiFi + Battery */}
          <div className="flex items-center gap-1.5 justify-end mr-[-4px]">
            {/* Signal bars */}
            <svg width="15" height="10" viewBox="0 0 13 10" fill="none">
              <rect x="0" y="7" width="2" height="3" rx="0.5" fill="#18181b" />
              <rect
                x="3.5"
                y="5"
                width="2"
                height="5"
                rx="0.5"
                fill="#18181b"
              />
              <rect
                x="7"
                y="2.5"
                width="2"
                height="7.5"
                rx="0.5"
                fill="#18181b"
              />
              <rect
                x="10.5"
                y="0"
                width="2"
                height="10"
                rx="0.5"
                fill="#18181b"
              />
            </svg>
            {/* WiFi */}
            <svg
              width="14"
              height="12"
              viewBox="0 0 1024 1024"
              fill="#18181b"
              stroke="#18181b"
              strokeWidth="40"
              strokeLinejoin="round"
            >
              <path d="M512 192c-163 0-326 67.2-443 176.6-6.6 6-6.8 16.2-0.6 22.8l53.4 55.8c6.2 6.6 16.6 6.8 23.2 0.6 46.6-43.2 99.8-77.6 158.6-102 66-27.6 136.2-41.4 208.6-41.4s142.6 14 208.6 41.4c58.8 24.6 112 58.8 158.6 102 6.6 6.2 17 6 23.2-0.6l53.4-55.8c6.2-6.4 6-16.6-0.6-22.8C838 259.2 675 192 512 192z" />
              <path d="M226.4 555l57.2 56.6c6.2 6 16 6.4 22.4 0.6 56.6-50.2 129.2-77.8 205.8-77.8s149.2 27.4 205.8 77.8c6.4 5.8 16.2 5.4 22.4-0.6l57.2-56.6c6.6-6.6 6.4-17.2-0.6-23.4-75-67.8-175.2-109.2-285-109.2s-210 41.4-285 109.2c-6.6 6.2-6.8 16.8-0.2 23.4z" />
              <path d="M512 648.4c-46.8 0-89.2 19.6-118.8 51-6 6.4-5.8 16.2 0.4 22.4l106.8 105.4c6.4 6.4 16.8 6.4 23.2 0l106.8-105.4c6.2-6.2 6.4-16 0.4-22.4-29.6-31.2-72-51-118.8-51z" />
            </svg>
            {/* Battery */}
            <svg width="20" height="10" viewBox="0 0 25 12" fill="none">
              <rect
                x="0.5"
                y="0.5"
                width="21"
                height="11"
                rx="2"
                stroke="#18181b"
                strokeWidth="1.2"
              />
              <rect x="2" y="2" width="18" height="8" rx="1" fill="#18181b" />
              <path d="M23 4v4a2 2 0 000-4z" fill="#18181b" opacity="0.4" />
            </svg>
          </div>
        </div>

        <div className="flex-1 min-h-0 flex flex-col">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PhoneFrame;
